var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg--white"},[_c('SetupCanvas',{ref:"setupCanvasChild",attrs:{"msg":_vm.pathwayName,"sk":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }